import React from "react";
import { Images } from "./Images";
import "../CSS/Soicalmedia.css";

const Socialmedia=()=>{
    return(
        <div className="Connectwithme">
            <div className="Headingconnecting">
                <p>CONNECT WITH ME</p>
            </div>
            <div className="Threeicons">
                <a href="https://www.linkedin.com/in/vishnu-s-330881189/" target="_blank"><img src={Images.Linkedincontact} alt="LinkedIn_Icon"/></a>
                <a href="https://dribbble.com/Vishnu_S" target="_blank"><img src={Images.Dribbblecontact} alt="Dribbble_icon"/></a>
                <a href="https://www.instagram.com/design.studio57/" target="_blank"><img src={Images.Instagramcontact} alt="Instagram_Icon"/></a>
            </div>
            <div className="Parentconnectingindia">
                <div className="Contactcardview">
                            <Contact Iconss={Images.Mail} Heading={"Email"} Subheading={"Vishnucse57@gmail.com"}/>
                            <Contact Iconss={Images.Phone} Heading={"Number"} Subheading={"+91 88701 05224"}/>
                    </div>
            </div>
                
            
        </div>
    )
}


const Contact=({Iconss, Heading, Subheading })=>{
    return(
        <div className="connectingindia">
            <img src={Iconss} className="numbermail"></img>
        <div className="mailnumberline">
            <img src={Images.Line} className="Borderline" />
            <div className="emailnumber">
                <p className="Contactemail">{Heading}</p>
                <p className="Contactmobilenumbers">{Subheading}</p>
            </div>
        </div>
    </div>
    )
}


export default Socialmedia;